// Temas por organización.
//
// Un tema es un paquete de componentes que reemplaza el layout y las pantallas
// clave del alumno para UNA organización (su `branding.theme`). Todo lo que el
// tema no exporta cae a la UI por defecto del LMS, así el resto de las orgs no
// cambia en nada.
//
// Contrato de un tema (`client/src/themes/<nombre>/index.js`), todo opcional:
//
//   export default {
//     Login,        // ({ org, slug, hostMode })           login de la org
//     Shell,        // ({ children, org, user, isAdmin })  layout con nav
//     Home,         // ()                                   inicio del alumno
//     Route,        // ({ challengeId })                    ruta / catálogo / mapa
//     Lesson,       // ()  usa useParams: id/stageId/contentId
//     Exam,         // ()  usa useParams: challengeId/stageId/examId
//     Certificate,  // ({ code })
//     Dashboard,    // ()  panel del admin de la org
//     Profile,      // ()
//     routes: [{ path, element }],  // rutas extra dentro del shell (ej. /noticias)
//     publicRoutes: [{ path, element }],
//   }
//
// Los temas NO traen datos propios: leen la API del LMS a través de
// `client/src/themes/data` (endpoints con filtro por organización). Solo
// cambian la presentación.
//
// Cada tema se carga lazy: el bundle de Buffalo no viaja a una org que no lo usa.

const THEMES = {
  buffalo: () => import("./buffalo"),
  oxxo: () => import("./oxxo"),
  aclara: () => import("./aclara"),
};

export const hasTheme = (name) => Boolean(name && name !== "default" && THEMES[name]);

export const loadTheme = async (name) => {
  if (!hasTheme(name)) return null;
  const mod = await THEMES[name]();
  return mod.default || mod;
};

export default THEMES;
